// Module
var code = "<ir-irisity-background-wrapper> <mm-login-form state-after-login=\"'dashboard'\"></mm-login-form> </ir-irisity-background-wrapper> ";
// Exports
var _module_exports = code;;
var path = '/App/Components/Login/Login.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;